import { apiClient } from "./client";
import { throwApiError } from "./response-error";
import type {
  ScheduleCalendarFilters,
  ScheduleSeriesCreateInput,
  ScheduleSeriesCreatePreviewInput,
  ScheduleSeriesRepository,
  ScheduleSeriesUpdateInput,
  ScheduleSeriesUpdatePreviewInput,
} from "./schedule-series-models";
import { mutationHeaders, sessionHeaders } from "./session-headers";

export class ApiScheduleSeriesRepository implements ScheduleSeriesRepository {
  async listScheduleCalendar(filters: ScheduleCalendarFilters, signal?: AbortSignal) {
    const result = await apiClient.GET("/v1/admin/schedule-calendar", {
      params: { header: await sessionHeaders(), query: filters },
      signal: signal ?? null,
    });
    if (!result.data) return throwApiError(result.error, result.response);
    return result.data;
  }
  async listScheduleSeries(offeringId: string, page = 1, signal?: AbortSignal) {
    const result = await apiClient.GET("/v1/admin/partner-offerings/{offeringId}/schedule-series", {
      params: {
        header: await sessionHeaders(),
        path: { offeringId },
        query: { page, pageSize: 20 },
      },
      signal: signal ?? null,
    });
    if (!result.data) return throwApiError(result.error, result.response);
    return result.data;
  }
  async getScheduleSeries(seriesId: string, signal?: AbortSignal) {
    const result = await apiClient.GET("/v1/admin/schedule-series/{seriesId}", {
      params: { header: await sessionHeaders(), path: { seriesId } },
      signal: signal ?? null,
    });
    if (!result.data) return throwApiError(result.error, result.response);
    return result.data;
  }
  async previewScheduleSeries(
    offeringId: string,
    input: ScheduleSeriesCreatePreviewInput,
    signal?: AbortSignal,
  ) {
    const result = await apiClient.POST(
      "/v1/admin/partner-offerings/{offeringId}/schedule-series-preview",
      {
        body: input,
        params: { header: await sessionHeaders(), path: { offeringId } },
        signal: signal ?? null,
      },
    );
    if (!result.data) return throwApiError(result.error, result.response);
    return result.data;
  }
  async previewScheduleSeriesUpdate(
    seriesId: string,
    input: ScheduleSeriesUpdatePreviewInput,
    signal?: AbortSignal,
  ) {
    const result = await apiClient.POST("/v1/admin/schedule-series/{seriesId}/preview", {
      body: input,
      params: { header: await sessionHeaders(), path: { seriesId } },
      signal: signal ?? null,
    });
    if (!result.data) return throwApiError(result.error, result.response);
    return result.data;
  }
  async createScheduleSeries(offeringId: string, input: ScheduleSeriesCreateInput) {
    const result = await apiClient.POST(
      "/v1/admin/partner-offerings/{offeringId}/schedule-series",
      {
        body: input,
        params: { header: await mutationHeaders(), path: { offeringId } },
      },
    );
    if (!result.data) return throwApiError(result.error, result.response);
    return result.data;
  }
  async updateScheduleSeries(seriesId: string, input: ScheduleSeriesUpdateInput) {
    const result = await apiClient.PATCH("/v1/admin/schedule-series/{seriesId}", {
      body: input,
      params: { header: await mutationHeaders(), path: { seriesId } },
    });
    if (!result.data) return throwApiError(result.error, result.response);
    return result.data;
  }
}
